// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2iQNd","box":"WorkspacesBox_box__32suU","node":"WorkspacesBox_node__3KWMS"};